import React from 'react';
import graph from './graph';
import { toast } from 'react-toastify';
import { Button, CircularProgress } from '@mui/material';
import { useMutation } from '@apollo/client';
import { useSelector } from 'react-redux';

export default function ControlCenter({ id, call, refetch }) {
  const { userToken } = useSelector((state) => state.auth);

  const [formUpdate, { loading }] = useMutation(graph.update.query, {
    context: {
      serviceName: graph.update.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onSubmit = async () => {
    try {
      const { data } = await formUpdate({
        variables: {
          ids: id,
          call_me: 2,
        },
      });
      if (data) {
        data[graph.update.name]?.messages.map((message) => toast.success(String(message)));
      }
    } catch (error) {}
  };

  return (
    <Button
      disabled={call !== 1}
      sx={{ width: 180 }}
      variant="contained"
      size="large"
      color="secondary"
      onClick={onSubmit}
    >
      {loading ? <CircularProgress color="inherit" size={25} /> : call !== 1 ? 'تماس گرفته شد' : 'تماس با مشتری'}
    </Button>
  );
}
